import { CustomerReviews } from '@hg/stylizator/components'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

export interface IAttributes
  extends Pick<
    React.ComponentProps<typeof CustomerReviews>,
    'title' | 'background' | 'showNavigation' | 'maxWidth' | 'showTrustpilot'
  > {
  reviews: NonNullable<React.ComponentProps<typeof CustomerReviews>['reviews']>
}

const CustomerReviewsBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  return (
    <CustomerReviews
      title={attributes.title ?? ''}
      maxWidth={attributes.maxWidth ?? 'default'}
      background={attributes?.background ?? 'white'}
      showNavigation={attributes?.showNavigation ?? false}
      reviews={attributes?.reviews?.length ? attributes.reviews : undefined}
      showTrustpilot={attributes?.showTrustpilot ?? false}
    />
  )
}

export default CustomerReviewsBlock
